export default {"src":"/_next/static/media/app-store-en.a2e763b8.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};